import { render, staticRenderFns } from "./OdocCaseTypesInput.vue?vue&type=template&id=2198f0ab"
import script from "./OdocCaseTypesInput.vue?vue&type=script&lang=js"
export * from "./OdocCaseTypesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports